<ng-template vdrDialogTitle>{{
  "package.bulk-update-rule" | translate
}}</ng-template>

<form [formGroup]="detailForm">
  <vdr-form-field [label]="'package.applied-for-order' | translate">
    <div>
      <a
        *ngFor="let item of items"
        class="button-ghost"
        style="margin-right: 6px; margin-top: 6px"
        [routerLink]="['/orders', item.orderId]"
      >
        <span>{{ item.order.code }}</span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </div>
  </vdr-form-field>

  <vdr-form-field
    [label]="'requestPurchase.productName' | translate"
    for="new-sku"
    style="margin-top: 1rem; width: 100%"
  >
    <div style="width: 100%">
      <product-selector
        (productSelected)="onSelectProduct($event)"
      ></product-selector>
    </div>
  </vdr-form-field>

  <vdr-form-field
    *ngIf="currentRule as rule"
    [label]="'package.current-rule' | translate"
    style="margin-top: 1rem"
  >
    <div style="display: flex; justify-content: space-between; width: 100%">
      <vdr-form-field
        [label]="'package.shipping-quantity' | translate"
        for="code"
        style="width: 80%"
      >
        <input
          id="shippingQuantity"
          type="number"
          [value]="rule.shippingQuantity"
          readonly
        />
      </vdr-form-field>
      <vdr-form-field
        [label]="'package.shipping-weight' | translate"
        for="shippingWeight"
        style="width: 80%; margin-left: 1rem; margin-right: 1rem"
      >
        <input
          id="shippingWeight"
          type="number"
          [value]="rule.shippingWeight"
          readonly
        />
      </vdr-form-field>
      <vdr-form-field
        [label]="'package.free-gift-quantity' | translate"
        for="freeGiftQuantity"
        style="width: 80%"
      >
        <input
          id="freeGiftQuantity"
          type="number"
          [value]="rule.freeGiftQuantity"
          readonly
        />
      </vdr-form-field>
    </div>
  </vdr-form-field>

  <vdr-form-field
    [label]="'package.new-rule' | translate"
    style="margin-top: 1rem"
  >
    <div style="display: flex; justify-content: space-between; width: 100%">
      <vdr-form-field
        [label]="'package.shipping-quantity' | translate"
        for="code"
        style="width: 80%"
      >
        <input
          id="shippingQuantity"
          type="number"
          formControlName="shippingQuantity"
          min="0"
        />
      </vdr-form-field>
      <vdr-form-field
        [label]="'package.shipping-weight' | translate"
        for="shippingWeight"
        style="width: 80%; margin-left: 1rem; margin-right: 1rem"
      >
        <input
          id="shippingWeight"
          type="number"
          formControlName="shippingWeight"
          min="0"
        />
      </vdr-form-field>
      <vdr-form-field
        [label]="'package.free-gift-quantity' | translate"
        for="freeGiftQuantity"
        style="width: 80%"
      >
        <input
          id="freeGiftQuantity"
          type="number"
          formControlName="freeGiftQuantity"
          min="0"
        />
      </vdr-form-field>
    </div>
  </vdr-form-field>
</form>

<div *ngIf="affectOrders !== null" style="margin-top: 1rem;">
  <div style="color: red">
    {{ "package.total-affected-orders" | translate }} : {{ affectOrders.length }}
  </div>
  <div>
    <a
      *ngFor="let item of affectOrders"
      class="button-ghost"
      style="margin-right: 6px; margin-top: 6px"
      [routerLink]="['/orders', item.id]"
    >
      <span>{{ item.code }}</span>
      <clr-icon shape="arrow right"></clr-icon>
    </a>
  </div>
</div>

<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>
  <button
    type="submit"
    [disabled]="detailForm.pristine || detailForm.invalid"
    (click)="save()"
    class="btn btn-primary"
  >
    {{ "common.bulk-update" | translate }}
  </button>
</ng-template>
